//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import React from "react";
import ReactTooltip from "react-tooltip";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// avatar imports
import { avatarPersonFragments } from "./AvatarPerson.gql";
import {
  IAvatarProps,
  IAvatarContainer,
  CreateInitialsPerson,
  RenderAvatarPerson,
} from "./Avatar.d";
import { AvatarGeneric } from "./AvatarGeneric";

// import { track, TrackingEvents } from '@util/analytics.util';
// state
import { setActiveViewCalendarProfile } from "@actions/chrome-extension.actions";
import { IReduxState } from "@reducers/root.reducer";

/////////////////////
// COMPONENT
/////////////////////
class AvatarPersonCmpt extends React.Component<IAvatarProps> {
  // ~-~-~-~-~-~-~-
  // Handlers
  // ~-~-~-~-~-~-~-
  private onClick = () => {
    const { backupCalendarId } = this.props;

    if (backupCalendarId && this.props.onClick) {
      this.props.onClick();
      this.props.setActiveViewCalendarProfile(backupCalendarId);
    }

    // const trackingMessage = person && person.isYou
    //   ? TrackingEvents.TEAM_HEALTH.SUMMARY_GO_TO_OWN_PROFILE
    //   : TrackingEvents.TEAM_HEALTH.SUMMARY_GO_TO_PROFILE;
    // track(trackingMessage, { calendarId: backupCalendarId, from: 'AvatarPerson', fromParent: parentName });
  };

  private createInitials = (
    person: CreateInitialsPerson | ISchema.IOrgPerson | null,
    backupCalendarId: string,
  ) => {
    let initials = "";
    if (person && person.profile && person.profile.givenName && person.profile.familyName) {
      initials = person.profile.givenName[0] + person.profile.familyName[0];
    } else if (person && person.profile && person.profile.givenName) {
      initials = person.profile.givenName[0];
    } else if (person && person.__typename === "Person" && person.primaryEmail) {
      initials = (person as ISchema.IPerson).primaryEmail[0];
    } else if (person && person.__typename === "OrgPerson" && person.primaryCalendarId) {
      initials = (person as ISchema.IOrgPerson).primaryCalendarId[0];
    } else if (backupCalendarId) {
      initials = backupCalendarId.slice(0, 1);
    } else {
      initials = "";
    }

    return initials?.toUpperCase?.();
  };

  // ~-~-~-~-~-~-~-
  // Rendering
  // ~-~-~-~-~-~-~-
  private renderAvatar = (
    person: RenderAvatarPerson | ISchema.IOrgPerson | null,
    style: IAvatarProps["style"],
    size: IAvatarProps["size"],
    initials: string,
    hideUserBadge: boolean,
    fastCrawlFinished: boolean,
    unClickable: boolean,
    responseStatus?: ISchema.ResponseStatusEnum,
  ) => {
    const props = {
      size,
      style,
      hideUserBadge,
      responseStatus,
      isNonActionable: !this.props.isChromeExtension,
      isUser:
        !!person &&
        ((person.__typename === "Person" && person.isUser) ||
          (person.__typename === "OrgPerson" && !!person.userId)),
      onClick: fastCrawlFinished && !unClickable ? this.onClick : undefined,
    };

    // prefer externalImageUrl
    if (person && person.profile && person.profile.externalImageUrl) {
      return <AvatarGeneric {...props} backgroundImage={person.profile.externalImageUrl} />;
    }

    // otherwise, render with some initials...
    return <AvatarGeneric {...props}>{initials}</AvatarGeneric>;
  };

  public render() {
    const {
      size,
      style,
      person,
      orgPerson,
      toolTipContent,
      backupCalendarId,
      unClickable,
      hideUserBadge,
      fastCrawlFinished,
      responseStatus,
    } = this.props;

    const initials = this.createInitials(person || orgPerson, backupCalendarId);

    if (!!toolTipContent) {
      const toolTipId = !!toolTipContent ? `tool-tip-${backupCalendarId}` : undefined;
      return (
        <div data-tip data-for={toolTipId}>
          {this.renderAvatar(
            person,
            style,
            size,
            initials,
            !!hideUserBadge,
            !!fastCrawlFinished,
            !!unClickable,
          )}
          <ReactTooltip multiline effect="solid" type="dark" id={toolTipId}>
            {toolTipContent}
          </ReactTooltip>
        </div>
      );
    }

    return this.renderAvatar(
      person || orgPerson,
      style,
      size,
      initials,
      !!hideUserBadge,
      !!fastCrawlFinished,
      !!unClickable,
      responseStatus,
    );
  }
}

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IAvatarContainer) {
  return {
    fastCrawlFinished: state.onboarding.fastCrawlFinished,
    isChromeExtension: state.webExtension.isWebExtension,
  };
}

export const AvatarPersonRedux = connect(mapStateToProps, {
  setActiveViewCalendarProfile,
})(AvatarPersonCmpt);

//////////////////
// RELAY
//////////////////
export const AvatarPerson = createFragmentContainer<IAvatarContainer>(
  AvatarPersonRedux,
  avatarPersonFragments,
);
